{
  "code": "邀请码",
  "error": {
    "details": "<ul>  \n<li>请检查是否有拼写错误，然后重试。</li>  \n<li>如果您遇到问题，请致电 {{phone}}（然后按选项2）。</li>  \n</ul>",
    "title": "该邀请码无效"
  },
  "helpMessage": "<p>丢失了邀请码或不确定该怎么做？<br />请致电 <a><strong>{{phone}}</strong></a> 联系我们（然后按 <strong>选项 2</strong>）。</p>",
  "text": "<p>请输入您的6位邀请码以开始。</p><p>您可以在电子邮件邀请中找到此代码，或者可能由转诊人提供。</p>",
  "title": "访问您的预约邀请"
}
